import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'info' | 'success' | 'warning' | 'error';

const tones: Record<Tone, string> = {
  info: 'bg-sky-100 text-sky-700 border-sky-300',
  success: 'bg-brand-50 text-brand-800 border-brand-200',
  warning: 'bg-sun-100 text-sun-700 border-sun-300',
  error: 'bg-coral-100 text-coral-700 border-coral-300',
};

export function Notice({
  tone = 'info',
  icon,
  title,
  children,
  className,
  live,
}: {
  tone?: Tone;
  icon?: ReactNode;
  title?: string;
  children?: ReactNode;
  className?: string;
  /** Announce changes to screen readers. */
  live?: boolean;
}) {
  return (
    <div
      role={live ? (tone === 'error' ? 'alert' : 'status') : undefined}
      className={cn('flex gap-3 rounded-2xl border-2 p-4', tones[tone], className)}
    >
      {icon && (
        <span aria-hidden className="shrink-0 text-xl leading-6">
          {icon}
        </span>
      )}
      <div className="flex flex-col gap-1">
        {title && <p className="font-extrabold">{title}</p>}
        {children && <div className="text-ink">{children}</div>}
      </div>
    </div>
  );
}
